
// SVG Icon: satellite
export default { id: "terriajs-satellite" };
export const id = "terriajs-satellite";
export const name = "satellite";
